import { type FC, type ComponentProps, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './HpSharedViewMoreLink.scss';

type Props = {
    viewMoreLink: string;
    viewMoreText?: ReactNode;
    onViewMoreClick?: ComponentProps<typeof Link>['onClick'];
    dataTn?: string;
    size?: 'large' | 'larger';
    weight?: 'regular' | 'heavy';
};

const defaultViewMoreText = (
    <FormattedMessage id="HpSharedHeader.viewMore" defaultMessage="View More" />
);

export const HpSharedViewMoreLink: FC<Props> = ({
    viewMoreLink,
    viewMoreText = defaultViewMoreText,
    onViewMoreClick,
    dataTn,
    size = 'large',
    weight = 'regular',
}) => (
    <Link
        className={classnames(styles.viewMore, styles[size], styles[weight])}
        href={viewMoreLink}
        dataTn={dataTn ? `${dataTn}-view-more-link` : `view-more-link`}
        onClick={onViewMoreClick}
    >
        {viewMoreText}
    </Link>
);
